import script from "./InfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSection.vue?vue&type=script&setup=true&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=40ae8f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ae8f74"]])

export default __exports__